import { Sprite } from "pixi.js";
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import CancelGroup from "slotworks/utils/contracts/cancel-group";
import Contract from "slotworks/utils/contracts/contract";
import { Easing } from "slotworks/utils/tween";

export class ZoomSymbolBehaviour extends AbstractSymbolBehaviour {

    protected sprite: Sprite;
    protected cancelGroup = new CancelGroup();
    protected originalScale: number;

    public win(): Contract<void> {
        this.cleanup();
        this.createBehaviourSprite();
        return this.startZoom(true);
    }

    public highlight(): Contract<void> {
        this.cleanup();
        this.createBehaviourSprite();
        return this.startZoom(true);
    }

    public static(): void {
        super.static();
        this.symbol.setVisible(true);
        this.cleanup();
    }

    protected cleanup(): void {
        if (this.sprite) {
            this.cancelGroup.cancel();
            this.cancelGroup.clear();
            this.animationLayer.remove(this.sprite);
            this.sprite.destroy();
            this.sprite = null;
        }
    }

    protected createBehaviourSprite(): void {
        this.sprite = this.symbol.createStaticCopy();
        this.animationLayer.add(this.sprite);
        this.originalScale = this.sprite.scale.x;
    }

    protected startZoom(loop = false): Contract<void> {
        this.symbol.setVisible(false);
        return this.cancelGroup.contract((resolve) => {
            this.cancelGroup.sequence([
                () => this.zoomTo(.7, 500, Easing.Sinusoidal.InOut),
                () => this.zoomTo(1, 500, Easing.Sinusoidal.InOut)
            ]).then(() => {
                if (loop) {
                    this.startZoom(true).execute();
                }
                resolve();
            });
        });
    }

    protected zoomTo(scale: number, duration: number, easing: (k: number) => number): Contract<void> {

        scale *= this.originalScale;

        return this.cancelGroup.contract<void>((resolve) => {
            const tween = this.cancelGroup.tween(this.sprite.scale);
            tween.to({ x: scale, y: scale }, duration);
            tween.easing(easing);
            tween.onComplete(() => resolve());
            tween.start();
        });
    }
}
